import {
  checkTokenType,
  getAccessToken,
  setPassword,
  validateEmail,
  validateOTP,
  validatePassword,
  verifyOTP,
  changePassword,
} from './states';

export const services = {
  checkTokenType,
  getAccessToken,
  setPassword,
  validateEmail,
  validateOTP,
  validatePassword,
  verifyOTP,
  changePassword,
};
